import React from 'react';
import { TextField } from '@mui/material';
import { useAppSelector, useAppDispatch } from '../../../../../../app/store';
import { updateSelectedContract } from '../../../../../../services/ContractService/contractSlice';

const ThresholdAmountEditor: React.FC = () => {
  const dispatch = useAppDispatch();
  const contract = useAppSelector((state) => state.contract.currentContract);

  const handleChange = (value: string) => {
    if (!contract) return;

    let processedValue: number | null = null;
    if (value !== '' && value !== null) {
      processedValue = parseFloat(value) || null;
    }

    dispatch(updateSelectedContract({
      implants: {
        ...contract.implants,
        thresholdAmount: processedValue
      }
    }));
  };

  if (!contract) return null;

  const isDisabled = contract.implants?.thresholdType === 'NA';

  return (
    <TextField
      label="Threshold Amount"
      value={contract.implants?.thresholdAmount || ''}
      onChange={(e) => handleChange(e.target.value)}
      type="number"
      inputProps={{
        step: 0.01,
        min: 0
      }}
      fullWidth
      size="small"
      variant="outlined"
      disabled={isDisabled}
      helperText={
        isDisabled 
          ? 'Not applicable' 
          : 'Threshold amount for implant pricing'
      }
    />
  );
};

export default ThresholdAmountEditor;